import { useEffect, useState } from "react";

const Duration = (props) => {
  const { duration, mix } = props;

  const [formattedDuration, setFormattedDuration] = useState();

  useEffect(() => {
    function formatMilliseconds(msString) {
      const ms = parseInt(msString, 10);
      const totalSeconds = Math.floor(ms / 1000);

      const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
      const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(
        2,
        "0"
      );
      const seconds = String(totalSeconds % 60).padStart(2, "0");

      setFormattedDuration(`${hours}:${minutes}:${seconds}`);
    }

    formatMilliseconds(duration);
  }, [mix]);

  return formattedDuration;
};

export default Duration;
